import React from 'react'
import PropTypes from 'prop-types'

export default function GenAIPageItems (props) {
    const { itemsPerPage,handleChangeSelectItems,customWidth } = props
    return (
      <div className="gen-ai-ims-result-select-outer-wrapper">
          <span className="gen-ai-ims-result-select-label">Items Per Page:&nbsp;</span>
          <span style={{width:customWidth ? "35%" : "30%"}}>
            <select 
              className="gen-ai-ims-result-select-wrapper" 
              onChange={e=>handleChangeSelectItems(e.target.value)} 
              defaultValue={itemsPerPage}
            >    
                <option>10</option>
                <option>25</option>
                <option>50</option>
                <option>75</option>
                <option>100</option>
                <option>200</option>
                <option>400</option>
            </select>
          </span>
      </div>
    )
}
GenAIPageItems.propTypes = {
    itemsPerPage:PropTypes.string.isRequired,
    handleChangeSelectItems: PropTypes.func
}

